import type { ComponentProps } from "react";

export default function MegaphoneIcon(props: ComponentProps<"svg">) {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M3.33333 11.6666L4.64553 16.9154C4.68243 17.063 4.70089 17.1368 4.72271 17.2013C4.93596 17.8309 5.50292 18.2735 6.16542 18.3277C6.23324 18.3333 6.30932 18.3333 6.46148 18.3333C6.65202 18.3333 6.74729 18.3333 6.82755 18.3255C7.62082 18.2485 8.2486 17.6208 8.32554 16.8275C8.33333 16.7472 8.33333 16.652 8.33333 16.4614V4.58326M15.4167 11.2499C17.0275 11.2499 18.3333 9.94409 18.3333 8.33326C18.3333 6.72243 17.0275 5.41659 15.4167 5.41659M8.54165 4.58326H5.41666C3.34559 4.58326 1.66666 6.26219 1.66666 8.33326C1.66666 10.4043 3.34559 12.0833 5.41666 12.0833H8.54166C10.0137 12.0833 11.8144 12.8723 13.2036 13.6296C14.014 14.0714 14.4192 14.2923 14.6846 14.2598C14.9307 14.2297 15.1168 14.1192 15.2611 13.9175C15.4167 13.7 15.4167 13.2649 15.4167 12.3947V4.27183C15.4167 3.40159 15.4167 2.96647 15.2611 2.749C15.1168 2.54734 14.9307 2.43684 14.6846 2.4067C14.4192 2.37419 14.014 2.59509 13.2036 3.03689C11.8144 3.79419 10.0137 4.58326 8.54165 4.58326Z"
        stroke="rgba(13,48,80)"
        stroke-opacity="0.8"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
}
